import Avatar from "antd/es/avatar/avatar";
import { FC } from "react";
import {
  forwardArrowSVG,
  goldenStarSVG,
  grayPointSVG,
  profileSVG,
  smallClockSVG,
  trashSVG,
} from "../../../assets/SVGs/SVGs";
import { Button } from "antd";
import { getDurationInMinutes, getWeekDay } from "../../../utils/DateUtils";
import { useIntl } from "react-intl";
import { UserOutlined } from "@ant-design/icons";

import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

type ReviewProps = {
  review: any;
  setSelectedReview: React.Dispatch<any>;
};
const ClientReview: FC<ReviewProps> = ({ review, setSelectedReview }) => {
  const { locationId, currentLang } = useSelector(
    (state: {
      calendar: { locationId: number | null };
      user: { currentLang: "en" | "ar" };
    }) => ({
      locationId: state?.calendar?.locationId,
      currentLang: state.user.currentLang,
    })
  );
  const intl = useIntl();

  return (
    <div className="p-3 bg-white rounded-lg grid grid-cols-1 md:grid-cols-6 gap-2">
      <div className="cols-span-1 md:col-span-4 bg-[#FBFBFF] p-3 rounded">
        <div className="flex flex-col sm:flex-row items-center justify-between ">
          <div className="flex gap-2 items-center">
            <Avatar
              size={30}
              src={review?.user?.image}
              icon={<UserOutlined />}
              className="bg-gray"
            >
              {review?.user?.name?.charAt(0)?.toUpperCase()}
            </Avatar>
            <span className="capitalize">{review?.user?.name}</span>
            <span className="text-[#CF953D]">({review?.rate})</span>
            <span>{goldenStarSVG}</span>
          </div>
          <Button
            onClick={() => {
              setSelectedReview(review);
            }} // add rate id
            type="text"
            htmlType="button"
            className="flex gap-2  "
          >
            <span>{trashSVG}</span>
            <span className="text-color-sec-title text-sm">
              {" "}
              {intl.formatMessage({
                id: "delete_rating",
              })}{" "}
            </span>
          </Button>
        </div>
        <p className="p-4 bg-white rounded-lg text-color-sec-title text-sm">
          {review?.comments}
        </p>
      </div>
      <div className="space-y-2 cols-span-1 md:col-span-2 text-sm bg-[#FBFBFF] p-3 rounded ">
        <div className="flex items-center justify-between p-2">
          <div>
            {intl.formatMessage({
              id: "booking_details",
            })}
          </div>
          <div>
            <Link
              to={`/calendar?id=${review?.rateable?.id}`}
              className=""
              target="_blank"
            >
              {forwardArrowSVG}
            </Link>
          </div>
        </div>
        <div className="flex items-center gap-1 text-sm text-color-sec-title ">
          <span className="translate-y-[2px]">{smallClockSVG}</span>
          <span>
            {getWeekDay(new Date(review?.rateable?.date), currentLang)}
          </span>
          <span>{review?.rateable?.date}</span>
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          {[
            ...review?.rateable?.appointment_services,
            ...review?.rateable?.appointment_packages,
          ]?.map(
            (
              item: {
                id: number;
                team_member: { name: string; media: string; id: number };
              },
              i
            ) => (
              <div className="flex items-center gap-2">
                <span>{profileSVG}</span>
                <span className="text-color-sec-title">
                  {item?.team_member?.name}
                </span>
              </div>
            )
          )}
        </div>
        <div>
          <div className="flex items-center gap-2 ">
            <span className="text-color-primary ">
              {review?.rateable?.appointment_services_count || 0}
            </span>
            <span className="text-color-primary capitalize">
              {" "}
              {intl.formatMessage({
                id: "services",
              })}{" "}
            </span>
            <span>{grayPointSVG}</span>
            <span className="text-color-primary ">
              {review?.rateable?.appointment_packages_count || 0}
            </span>
            <span className="text-color-primary">
              {" "}
              {intl.formatMessage({
                id: "packages",
              })}{" "}
            </span>
            <span>{grayPointSVG}</span>
            <span className="text-color-sec-title">
              {getDurationInMinutes(
                review?.rateable?.start_time,
                review?.rateable?.finish_time
              )}
              <small className="text-xs">
                {" "}
                {intl.formatMessage({
                  id: "minutes",
                })}{" "}
              </small>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientReview;
